<template>
  <div class="btns-social mt-3 mt-md-4">
    <a @click="logInWithFacebook()" class="btn btn-face"><font-awesome-icon :icon="{ prefix: 'fab', iconName: 'facebook' }"/> Entrar com o Facebook</a>
    <a @click="loginWithGoogle()" class="btn btn-google"><font-awesome-icon :icon="{ prefix: 'fab', iconName: 'google' }"/> Entrar com o Google</a>
  </div>
</template>

<script>
export default {
  name: 'Social',
  watch: {
    '$store.getters.errorsLoginSocial': function() {
        this.$bvToast.toast(this.$store.getters.errorsLoginSocial, {
          title: 'Login',
          variant: 'danger',
          solid: true,
          autoHideDelay: 5000
        })
    }
  },
  methods: {
    loginWithGoogle () {
      this.$gAuth
      .signIn()
      .then(async GoogleUser => {
        let loader = this.$loading.show()
        await this.$store.dispatch('loginSocialGoogle', { access_token: GoogleUser.getAuthResponse().access_token })
        loader.hide()
      })
    },
    async logInWithFacebook() {
      await this.loadFacebookSDK(document, "script", "facebook-jssdk");
      await this.initFacebook();
    },
    async initFacebook() {
      window.fbAsyncInit = () => {
        window.FB.init({
          appId: process.env.VUE_APP_FACEBOOK_CLIENT_ID, //You will need to change this
          cookie: true, // This is important, it's not enabled by default
          version: "v13.0"
        });
        
        window.FB.login( async (response) => {
          if (response.authResponse) { 
            let loader = this.$loading.show()
            await this.$store.dispatch('loginSocialFacebook', { access_token: response.authResponse.accessToken })
            loader.hide()
          }
        });
      };
    },
    async loadFacebookSDK(d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    }
  }
}
</script>